import { useEffect, useState } from 'react';

/**
 * @param cb
 * @param dependencies e.g, [isLoadingArticle, isLoadingContactChannels, ...]
 * @returns {enableSpinner: boolean}
 *
 * this hook is to manage the loader spinner component
 * if one of the dependencies is true, then the spinner should be enabled
 *
 * useage:
 * const { enableSpinner } = useLoaderHook(() => {
 *   any actions needed to be trigger after the spinner
 * }, [isLoadingArticle,....]);
 */
const useLoaderHook = function (cb, dependencies) {
  const [enableSpinner, setEnableSpinner] = useState(false);

  const handleEnableSpinner = () => {
    return [...dependencies].includes(true);
  };

  useEffect(() => {
    setEnableSpinner(handleEnableSpinner());
    cb();
  }, [...dependencies]);

  return {
    enableSpinner,
  };
};

export default useLoaderHook;
